import { render, staticRenderFns } from "./PolicyItem.vue?vue&type=template&id=85a50dde&scoped=true"
import script from "./PolicyItem.vue?vue&type=script&lang=js"
export * from "./PolicyItem.vue?vue&type=script&lang=js"
import style0 from "./PolicyItem.vue?vue&type=style&index=0&id=85a50dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a50dde",
  null
  
)

export default component.exports